import React from 'react';

const Profile = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-gray-900">Profile</h1>
        <p className="mt-2 text-gray-600">Manage your account settings and preferences</p>
        
        <div className="mt-8">
          <div className="card">
            <div className="card-body">
              <p className="text-gray-600">Profile management interface coming soon...</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
